import { handleTokenEpic, signInEpic, signOutEpic, signUpEpic } from 'components/Account'
import { handleErrorEpic, logHaActionOutcomeEpic } from 'components/Account/data/epic'
import {
  createCollectionEpic,
  deleteCollectionEpic,
  deletePlaceFromCollectionEpic,
  editCollectionEpic,
  fetchCollectionsAndPlacesEpic,
  savePlaceInCollectionEpic,
} from 'components/Collections'
import { RootState } from 'data/reducer'
import { AppEvent, logAppEvent } from 'lib/analytics'
import { AnyAction } from 'redux'
import { combineEpics, StateObservable } from 'redux-observable'
import { catchError, EMPTY, Observable } from 'rxjs'

import { fetchLocalizationDataEpic, setBrowserMapHeadersEpic } from './app'
import { fetchPdcItemEpic } from './pdc'
import { fetchRoutesEpic, setRouteWaypointsEpic } from './routePlanner'
import {
  clearRecentItemListEpic,
  fetchAutosuggestItemListEpic,
  fetchBrowseItemListEpic,
  fetchRecentListEpic,
  fetchReverseGeocodeItemListEpic,
  fetchSearchItemListEpic,
  setRecentItemEpic,
} from './search'
import { fetchCurrentPositionEpic } from './user'

const handleError = (val: unknown): void => {
  if (typeof val === 'string') {
    process.env.NODE_ENV === 'production'
      ? void logAppEvent(AppEvent.UnhandledErrorOccured, {
          Error: val,
          Stacktrace: undefined,
        })
      : console.error(val)
  } else {
    const error = val as Error
    process.env.NODE_ENV === 'production'
      ? void logAppEvent(AppEvent.UnhandledErrorOccured, {
          Error: `${error.name}: ${error.message}`,
          Stacktrace: error.stack,
        })
      : console.error(`${error.name}: ${error.message}`)
  }
}

export const rootEpic = (
  action$: Observable<AnyAction>,
  state$: StateObservable<RootState>
): Observable<AnyAction> =>
  combineEpics(
    clearRecentItemListEpic,
    createCollectionEpic,
    deleteCollectionEpic,
    deletePlaceFromCollectionEpic,
    editCollectionEpic,
    fetchAutosuggestItemListEpic,
    fetchBrowseItemListEpic,
    fetchCollectionsAndPlacesEpic,
    fetchCurrentPositionEpic,
    fetchLocalizationDataEpic,
    fetchPdcItemEpic,
    fetchRecentListEpic,
    fetchRoutesEpic,
    fetchReverseGeocodeItemListEpic,
    fetchSearchItemListEpic,
    handleErrorEpic,
    handleTokenEpic,
    logHaActionOutcomeEpic,
    savePlaceInCollectionEpic,
    setBrowserMapHeadersEpic,
    setRecentItemEpic,
    signInEpic,
    signOutEpic,
    signUpEpic,
    setRouteWaypointsEpic
  )(action$, state$, undefined).pipe(
    catchError((val: unknown) => {
      handleError(val)
      return EMPTY
    })
  )
